import React, { memo, useCallback, useState } from "react"
import { injectIntl } from "react-intl"
import PrintIcon from "@material-ui/icons/Print"
import _ from "lodash"
import pdfMake from "pdfmake/build/pdfmake"
import pdfFonts from "pdfmake/build/vfs_fonts"
import { Button } from "react-bootstrap"
import { useSnackbar } from "notistack"
import useDocDefinition from "./useDocDefinition"
import { toAbsoluteUrl } from "../../../../helpers"
import { isRLTLang } from "../../../../i18n"
import DownloadFile from "../extras/DownloadFile"
import {useControlUISelector} from ".."

pdfMake.vfs = pdfFonts.pdfMake.vfs

pdfMake.fonts = {
  main: {
    normal: toAbsoluteUrl(!isRLTLang() ? "/media/font/B612.ttf" : "/media/font/BigVesta.ttf"),
    bold: toAbsoluteUrl(!isRLTLang() ? "/media/font/B612-Bold.ttf" : "/media/font/BigVesta-Bold.ttf"),
    italics: toAbsoluteUrl(!isRLTLang() ? "/media/font/B612.ttf" : "/media/font/BigVesta.ttf"),
    bolditalics: toAbsoluteUrl(!isRLTLang() ? "/media/font/B612.ttf" : "/media/font/BigVesta.ttf")
  }
}

const sleep = (ms) =>  new Promise(resolve => setInterval(resolve, ms))

const DownloadItems = ({ title, printURL, intl }) => {
  const displayUIProps = useControlUISelector()
  const { enqueueSnackbar } = useSnackbar()

  const { shownDisplayFields: allFields, object, isFetching } = displayUIProps
  const documentDefinition = useDocDefinition({ allFields, object, title, intl })
  const [isDownloading, setDownloading] = useState(false)

  const download = (attempts = 3) => {
    let downloaded = false
    pdfMake.createPdf(documentDefinition).download("file.pdf", () => {
      setDownloading(false)
      downloaded = true
    })
    sleep(500).then(() => {
      if (attempts === 0){
        setDownloading(false)
        enqueueSnackbar(intl.formatMessage({ id: "GENERAL.ERROR_DOWNLOAD_PDF" }), {
          variant: "error",
          anchorOrigin: {
            vertical: "top",
            horizontal: "right"
          }
        })
      } else if (!downloaded && attempts > 0) {
        download(attempts - 1)
      }
    })
  }

  const onDownloadPDF = useCallback(() => {
    setDownloading(true)
    download()

    // eslint-disable-next-line
  }, [allFields, object])

  if (!_.isEmpty(printURL)) {
    return <DownloadFile endpoint={printURL} />
  }

  if (_.isEmpty(object) || isFetching) {
    return <></>
  }

  return (
    <Button
      disabled={isDownloading}
      onClick={onDownloadPDF}
      className="btn btn-sm btn-success mx-3 my-1 "
    >
      {isDownloading && <span className="px-5 spinner spinner-white" />}
      <PrintIcon />
    </Button>
  )
}

export default memo(injectIntl(DownloadItems))
